import { Component } from 'react';

import { FlowManagerEditModalComponentT } from 'fable/flowEditor';

import { FlowNodeTypes } from '../../../powerFlowShared/components/types';
import { FlowEmailNodeCloseT } from '../nodeTypes';

type PropsT = FlowManagerEditModalComponentT<FlowEmailNodeCloseT>;

export default class HiddenModal extends Component<PropsT> {
  componentDidMount() {
    const nodeOptions: FlowEmailNodeCloseT = {
      ...this.props.node,
      badges: [],
      childIds: [],
      icon: 'i-done',
      isAction: false,
      isEditable: false,
      isRemovable: true,
      nodeType: FlowNodeTypes.CLOSE,
      overlay: [],
      payload: null,
      text: 'Close email',
    };

    this.props.replaceNode(nodeOptions);
    this.props.triggerClose();
  }

  render() {
    return null;
  }
}
